// src/mocks/DemoBanner.js
import React from 'react';
import './DemoBanner.css';

export default function DemoBanner() {
    return (
        <div className="demo-banner">
            MODO DEMO
            <span>— Datos ficticios. Sin conexión al backend.</span>
        </div>
    );
}
